(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fsr-dachzelte-banner"] && !Shopify.designMode) return;
  try {
    
  let fsr_dachzelte_banner_images = document.querySelectorAll('.fsr-dachzelte-banner-image')
  let fsr_dachzelte_banner_floatings = document.querySelectorAll('.fsr-dachzelte-banner-floating-image')

  window.addEventListener('scroll', (event) => {
    const t = e => e.getBoundingClientRect().top
    let h = window.innerHeight

    fsr_dachzelte_banner_images.forEach(i => i.style.backgroundPosition = `50% ${t(i) / h * 100}%`)

    fsr_dachzelte_banner_floatings.forEach(i => i.style.transform = `translate(${window.innerWidth < 901 ? 0 : t(i.parentElement) / h * -10}%, ${t(i.parentElement) / h * -20}%)`)
  })

  window.addEventListener('load', () => window.dispatchEvent(new Event('scroll')))

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsr-dachzelte-usps"] && !Shopify.designMode) return;
  try {
     
  let fsr_dachzelte_usps_images = document.querySelectorAll('.fsr-dachzelte-usps-image')
  window.addEventListener('scroll', (event) => {
    fsr_dachzelte_usps_images.forEach(i => {
      i.style.backgroundPosition = `50% ${i.getBoundingClientRect().top / window.innerHeight * 50}%`
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsr-process"] && !Shopify.designMode) return;
  try {
    
  let skyvault_process_sections = Array.from(document.querySelectorAll('.fsr-skyvault-process'))
  skyvault_process_sections.forEach(section => {
    let slider = section.querySelector('.fsr-skyvault-process-right-main-slider')
    let slides = Array.from(section.querySelectorAll('.fsr-skyvault-process-right-main-slide'))
    let dots = Array.from(section.querySelectorAll('.fsr-skyvault-process-right-main-slide-dot'))
    let car = section.querySelector('.fsr-skyvault-process-right-main img')

    dots.forEach(dot => {
      let slide = dot.parentElement
      dot.addEventListener('click', () => {
        let page = Math.floor(slider.scrollLeft / slide.offsetWidth)
        slider.scrollLeft = (slide.dataset.slide - 1) * slide.offsetWidth
      })
    })

    slider.addEventListener('scroll', () => {
      let page = Math.round(slider.scrollLeft / slides[0].offsetWidth) + 1
      if(window.innerWidth <= 900){
        car.style.left = (70 + 20 * page) + 'px'
      }else {
        car.style.left = (350 + 20 * page) + 'px'
      }
      
      dots.forEach(dot => {
        if(dot.parentElement.dataset.slide != page){
          dot.parentElement.classList.remove('active')
        } else {
          dot.parentElement.classList.add('active')
        }
      })
    })
  })

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fsr-skyvault-reviews"] && !Shopify.designMode) return;
  try {
    
  let fsr_skyvault_review_sections = Array.from(document.querySelectorAll('.fsr-skyvault-reviews'))
  fsr_skyvault_review_sections.forEach(section => {
    let left = section.querySelector('#fsr-skyvault-reviews-left')
    let right = section.querySelector('#fsr-skyvault-reviews-right')
    let slider = section.querySelector('.fsr-skyvault-reviews-reviews')
    let slide = slider.querySelector('.fsr-skyvault-reviews-review')
    let gap = 40
    let pages = Array.from(slider.querySelectorAll('.fsr-skyvault-reviews-review')).length

    right.addEventListener('click', () => {
      if(right.classList.contains('fsr-skyvault-reviews-left-active')){
        console.log('click')
        let page = Math.floor(slider.scrollLeft / (slide.offsetWidth + gap))
        slider.scrollLeft = (page + 1) * (slide.offsetWidth + gap)
        console.log(slider.scrollWidth)
        if(page + 1 >= pages){
          right.classList.remove('fsr-skyvault-reviews-left-active')
        }
      }
    })

    left.addEventListener('click', () => {
      if(left.classList.contains('fsr-skyvault-reviews-left-active')){  
        console.log('click')
        let page = Math.ceil(slider.scrollLeft / (slide.offsetWidth + gap))
        slider.scrollLeft = (page - 1) * (slide.offsetWidth + gap)
        if(page - 1 <= 0){
          left.classList.remove('fsr-skyvault-reviews-left-active')
        }
      }
    })

    slider.addEventListener('scroll', () => {
      if (slider.scrollLeft == 0) {
        left.classList.remove('fsr-skyvault-reviews-left-active')
      }else{
        left.classList.add('fsr-skyvault-reviews-left-active')
      }
      if (slider.scrollLeft >= pages * (slide.offsetWidth + gap) - slider.offsetWidth) {
        right.classList.remove('fsr-skyvault-reviews-left-active')
      }else{
        right.classList.add('fsr-skyvault-reviews-left-active')
      }
    })
  })

  } catch(e) { console.error(e); }
})();
})();
